const getMainKey = () => {
  const IS_MAC = navigator?.userAgent?.toLowerCase()?.includes('mac');
  const MAIN_KEY = IS_MAC ? '⌘' : 'Ctrl';
  const ALT_KEY = IS_MAC ? '⌥' : 'Alt';
  return { MAIN_KEY, ALT_KEY, IS_MAC };
};

export const { MAIN_KEY, ALT_KEY, IS_MAC } = getMainKey();
